import styled from '@emotion/styled';
import { Checkbox } from 'antd';

export const CheckboxView = styled(Checkbox)`
  .ant-checkbox {
    &.ant-checkbox-disabled {
      .ant-checkbox-inner {
        background-color: #eaeaea !important;
      }
    }
    .ant-checkbox-inner {
      background-color: #ffffff !important;
      width: 20px;
      height: 20px;
      &:after {
        border-color: #4caf50;
        inset-inline-start: 30%;
        width: 6.714286px;
        height: 10.142857px;
      }
    }
    &:hover {
      .ant-checkbox-inner {
        border-color: #4caf50;
        background-color: unset;
      }
    }
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    border-color: #4caf50 !important;
  }
`;
